module.exports = __webpack_public_path__ + "img/maintenance-live.f8a841d8.jpg";